import { useMemo } from 'react';

import { useFishGroupsController_getLocations } from '@/services/hooks';
import type { FishGroupLocationHistoryItemDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import type { UseGetFishGroupLocationsResult } from './historyTypes';
import { mapFishGroupLocationsToDomain } from './mappers';

export const useGetFishGroupLocations = (
    clientId: number,
    fishGroupId: number,
    options?: DomainQueryOptions<FishGroupLocationHistoryItemDto[]>
): UseGetFishGroupLocationsResult => {
    const query = useFishGroupsController_getLocations(clientId, fishGroupId, options);

    const locations = useMemo(() => {
        if (!query.data?.data) return [];
        return mapFishGroupLocationsToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: locations,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
